import React, { createContext, useState } from 'react';

// create context
const SidebarContext= createContext()
const SideBarProvider = ({children}) => {
  // sidebar context
  const [isOpen,setIsOpen]= useState(false);
  const handleClose =()=>
  {
    setIsOpen(false)
  }
 
  return <SidebarContext.Provider
  value={{isOpen,setIsOpen,handleClose}}
  >
    {children}
  </SidebarContext.Provider>;
};

export {SidebarContext,SideBarProvider};
